import React, { useEffect, useMemo } from "react";
import { getAttendanceByUserId, getOwners, getUser, getUserLogHours } from "../../redux/selector";
import { fetchDataAndUpdateStore } from "../../redux/actions";
import { useSelector } from "react-redux";
import useFetchIfNeeded from "../../redux/useFetchIfNeeded";
import CRMAttendanceCalendar from "./CRMAttendanceCalendar";

const AttendanceInfoCalendar = ({ }) => {
    const containerStyle = useMemo(() => ({ width: '100%', height: '100%' }), []);
    const userInfo = useSelector(getUser);
    const users = useSelector(getOwners);

    const attendanceByUserId = useSelector(getAttendanceByUserId);

    useEffect(() => {
        if (!attendanceByUserId && userInfo?.userId) {
            fetchDataAndUpdateStore({
                key: "attendanceByUserId",
                inputData: userInfo?.userId,
            });
        }
    }, [attendanceByUserId, userInfo?.userId]);

    return (
        // <div className="col-xl-6">
        //     <div className="card p-3">
        <div className="inner-page" style={containerStyle}>
            <div className="dash-container">
                <CRMAttendanceCalendar attendanceByUserId={attendanceByUserId} />
            </div>
        </div>
    );
};

export default AttendanceInfoCalendar;